/**
 * 登录类型枚举 - 保留用于向后兼容
 */
export const enum AuthType {
  Email = 'email',
  Phone = 'phone'
}

/**
 * Tab选项项接口 - 使用泛型支持任意类型
 */
export interface Item<T = string> {
  type: T
  text: string
}

/**
 * Tabs组件属性接口 - 使用泛型
 */
export interface TabsProps<T = string> {
  items: Item<T>[]
  defaultSelected?: T
  onChange: (type: T) => void
}

/**
 * TabItem组件属性接口 - 使用泛型
 */
export interface ItemProps<T = string> {
  item: Item<T>
  isSelected: boolean
  onPress: (type: T) => void
}
